import { render } from "./DestinationForm.vue?vue&type=template&id=8e2233cc"
import script from "./DestinationForm.vue?vue&type=script&lang=js"
export * from "./DestinationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__